module.exports = __webpack_public_path__ + "static/media/companion-card.fdf33db6.png";